import $ from 'jquery'
import Swiper from 'swiper/bundle'
import { Fancybox } from '@fancyapps/ui'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.creation-block__slider')

  new Swiper(wrapper[0], {
    slidesPerView: 1,
    spaceBetween: 30,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.creation-block__nav--next',
      prevEl: '.creation-block__nav--prev',
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
    },
  })

  Fancybox.bind(`[data-vn-gallery='creation-${$block.attr('data-id')}']`, {
    groupAll: true,
    caption: function (fancybox, carousel, slide) {
      var textReturn = ''
      if ( slide.$trigger.querySelector('.feed-creation__alt') ) {
        textReturn = slide.$trigger.querySelector('.feed-creation__alt').innerHTML
      }
      return textReturn
    },
  })
}

$('.creation-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=vn-creation', initializeBlock)
}
